export default __webpack_public_path__ + "static/media/pre_employment.c15dd337.svg";